// 直连Google Pay API(gateway=stripe),绕开Stripe paymentRequest/Element的钱包可用性检测
// 背景:Stripe按账户下发capabilityEnabledCardNetworks,该账户缺visa/mastercard导致
// Element永不渲染谷歌按钮;直连后卡组织由我方指定,Google返回的即Stripe tok_,
// 后端复用stripToken预授权链路(与苹果支付同链路,已修复token挂载问题)
let payClient = null

const isTestKey = (key) => (key || '').startsWith('pk_test')

// 加载pay.js并初始化PaymentsClient
export const loadGpay = (publishableKey) => {
  return new Promise((resolve, reject) => {
    if (window.google && window.google.payments) {
      payClient = new window.google.payments.api.PaymentsClient({
        environment: isTestKey(publishableKey) ? 'TEST' : 'PRODUCTION'
      })
      return resolve(payClient)
    }
    const s = window.document.createElement('script')
    s.src = 'https://pay.google.com/gp/p/js/pay.js'
    s.onload = () => {
      payClient = new window.google.payments.api.PaymentsClient({
        environment: isTestKey(publishableKey) ? 'TEST' : 'PRODUCTION'
      })
      resolve(payClient)
    }
    s.onerror = () => reject(new Error('Google Pay SDK加载失败'))
    window.document.head.appendChild(s)
  })
}

// 构造支付请求;merchantId仅PRODUCTION需要(Google Pay Business Console注册获得),
// TEST环境带未过审的merchantId会报OR-BIBED_06(此商家无法接受付款),必须省略
export const buildGpayRequest = ({ price, currency, country, merchantName, publishableKey, merchantId }) => {
  const useMerchantId = !isTestKey(publishableKey) ? merchantId : null
  const base = {
    apiVersion: 2,
    apiVersionMinor: 0,
    allowedPaymentMethods: [
      {
        type: 'CARD',
        parameters: {
          // 仅接受设备令牌卡(CRYPTOGRAM_3DS):已完成设备级验证,与Apple Pay同安全等级,
          // 欧盟PSD2下不会再要求3DS二次验证;PAN_ONLY裸卡在EUR区会报authentication_required
          allowedAuthMethods: ['CRYPTOGRAM_3DS'],
          allowedCardNetworks: ['VISA', 'MASTERCARD', 'AMEX', 'DISCOVER', 'JCB']
        },
        tokenizationSpecification: {
          type: 'PAYMENT_GATEWAY',
          parameters: {
            gateway: 'stripe',
            'stripe:version': '2018-10-31',
            'stripe:publishableKey': publishableKey
          }
        }
      }
    ]
  }
  return {
    ...base,
    merchantInfo: {
      merchantName,
      ...(useMerchantId ? { merchantId: useMerchantId } : {})
    },
    transactionInfo: {
      totalPriceStatus: 'FINAL',
      totalPrice: Number(price || 0).toFixed(2),
      currencyCode: (currency || 'EUR').toUpperCase(),
      countryCode: country || 'PT'
    }
  }
}

// 可用性预检:要求用户钱包里已有可用卡(与Stripe Element同款检测语义)
export const checkGpayReady = (publishableKey, reqParams) => {
  return loadGpay(publishableKey).then((client) =>
    client.isReadyToPay({ ...buildGpayRequest({ ...reqParams, publishableKey }), existingPaymentMethodRequired: true })
  )
}

// 拉起谷歌钱包,resolve出Stripe tok_ id;用户取消时reject {cancelled:true}
export const requestGpayToken = (publishableKey, reqParams) => {
  return loadGpay(publishableKey).then((client) =>
    client.loadPaymentData(buildGpayRequest({ ...reqParams, publishableKey })).then((paymentData) => {
      const tokenJson = paymentData.paymentMethodData.tokenizationData.token
      const token = JSON.parse(tokenJson)
      return token.id
    })
  )
}
